import { AccessType } from './access-type.enum';

/**
 * Permission for a specific page or feature
 * Identified by permissionKey
 */
export interface Privilege {
  /**
   * Key identifying the permission
   * Format: "Page.SubArea.Page" or "Page.SubArea.Feature"
   * Examples:
   * - "Administration.Users.Page"
   * - "Administration.Users.Assign_Data_Analyst"
   * - "Dashboard.Page"
   */
  permissionKey: string;

  /**
   * Access level for this permission
   */
  access: AccessType;
}

/**
 * Mapping of role to list of privileges
 */
export interface RolePrivileges {
  role: string;
  privileges: Privilege[];
}
